module.exports = __webpack_public_path__ + "ad6dad75c42ec2a20804267760d002a8.MP3";